"use strict";

exports.__esModule = true;
exports.isFeatureEnabled = void 0;
var _types = require("@wix/ambassador-bookings-services-v2-service/types");
var _legacyToSettingsFeatures = require("./legacyToSettingsFeatures");
const isFeatureEnabled = ({
  activeFeatures,
  service
}) => {
  var _asSettings$key;
  const asSettings = 'bookingsAppointments' in activeFeatures ? activeFeatures : (0, _legacyToSettingsFeatures.legacyToSettingsFeatures)(activeFeatures);
  const keyByType = {
    [_types.ServiceType.APPOINTMENT]: 'bookingsAppointments',
    [_types.ServiceType.COURSE]: 'bookingsCourses',
    [_types.ServiceType.CLASS]: 'bookingsGroups'
  };
  const key = keyByType[service.type];
  return key ? !!((_asSettings$key = asSettings[key]) != null && _asSettings$key.enabled) : true;
};
exports.isFeatureEnabled = isFeatureEnabled;
//# sourceMappingURL=activeFeature.js.map